import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  useGridApiContext,
  useGridSelector,
  gridRowCountSelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-premium";
import { Box, Typography, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  onAdd: () => void;
};

export default function AdditionalDocumentsToolbar({ onAdd }: Props) {
  const { t } = useAppTranslation("common");

  const apiRef = useGridApiContext();
  const total = useGridSelector(apiRef, gridRowCountSelector);

  return (
    <GridToolbarContainer sx={{ px: 2, py: 1.5 }}>
      {/* LEFT */}
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6">
          {t("Dodatkowe dokumenty")}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {t("Łącznie")}: {total}
        </Typography>
      </Box>

      {/* RIGHT */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          size="small"
          variant="contained"
          startIcon={<Add />}
          onClick={onAdd}
        >
          {t("Dodaj dokument")}
        </Button>

        <GridToolbarFilterButton />
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
      </Box>
    </GridToolbarContainer>
  );
}
